import CONFIG from '../config/config'

const normalizePrefix = (prefix: string): string => `+${prefix.replace(/[^\d]/g, '')}`

const normalizedCountryPrefixes = Array.from(
  new Set(
    CONFIG.COUNTRY_CODES
      .map((country) => country.prefix)
      .filter(Boolean)
      .map(normalizePrefix)
  )
).sort((a, b) => b.length - a.length)

export const formatPhoneNumberWithPrefixSpacing = (phoneNumber?: string): string => {
  if (!phoneNumber) return ''

  const trimmedPhone = phoneNumber.trim()

  if (!trimmedPhone.startsWith('+')) {
    return trimmedPhone
  }

  const normalizedPhone = trimmedPhone.replace(/\s+/g, '').replace(/[^\d+]/g, '')

  const matchedPrefix = normalizedCountryPrefixes.find(
    (prefix) =>
      normalizedPhone.startsWith(prefix) &&
      normalizedPhone.length > prefix.length
  )

  if (matchedPrefix) {
    return `${matchedPrefix} ${normalizedPhone.slice(matchedPrefix.length)}`
  }

  const fallbackMatch = normalizedPhone.match(/^(\+\d{1,4})(\d+)$/)
  if (fallbackMatch) {
    return `${fallbackMatch[1]} ${fallbackMatch[2]}`
  }

  return trimmedPhone
}
